<template>
  <div class="header-box">
    <img src="https://static.hzjly.cn//authorizationserver/img/logo_subweb.png" class="img">
  </div>


</template>

<script>
  export default {
    name: "vheader",
    data() {
      return {}
    },
    mounted() {

    },
    methods: {}
  }
</script>

<style scoped>
  .header-box {
    width: 100%;
    text-align: center;
    padding-top: 30px;
    padding-bottom: 30px;
    height: auto;
    background-color: #f2f2f2;

  }

  .img {

  }
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue